import React from 'react';
import { Search, X } from 'lucide-react';

interface SearchInputProps {
    value: string;
    onChange: (value: string) => void;
    placeholder?: string;
    className?: string;
}

const SearchInput: React.FC<SearchInputProps> = ({
    value,
    onChange,
    placeholder = "Search...",
    className = ""
}) => {
    return (
        <div className={`relative mb-10 ${className}`}>
            {/* <div className="absolute inset-y-0 left-0 pl-5 flex items-center pointer-events-none">
                <Search className="h-4 w-4 text-white/70" />
            </div> */}
            <input
                type="text"
                value={value}
                onChange={(e) => onChange(e.target.value)}
                placeholder={placeholder}
                maxLength={256}
                className="w-full h-[53px] pl-[36px] pr-14 text-base border border-[#E761A0] rounded-full bg-transparent text-white placeholder-white focus:outline-none focus:ring-2 focus:ring-pink-500/30 transition-colors duration-200"
            />
            {value && (
                <button
                    onClick={() => onChange('')}
                    className="absolute right-0 top-0 h-[53px] w-[53px] rounded-full bg-[#E761A0] flex items-center justify-center text-white hover:bg-[#E761A0] transition-colors"
                >
                    <X className="h-4 w-4" />
                </button>
            )}
            {!value && (
                <div className="absolute right-0 top-0 h-[53px] w-[53px] rounded-full bg-[#E761A0] flex items-center justify-center pointer-events-none">
                    <Search className="h-4 w-4 text-white" />
                </div>
            )}
        </div>
    );
};

export default SearchInput;

